import React from 'react';
import {createRoot} from "react-dom/client";
import SearchBox from "../../Components/SearchBox";

const searchbox = document.getElementById('searchbox');
if (searchbox) {
    createRoot(searchbox).render(<SearchBox {...searchbox.dataset} />);
}
